export const GET_LOG = 'GAME_LOG/GET_LOG';
export const SET_LOG = 'GAME_LOG/SET_LOG';
